import {ITrackEventName, ITrackEventParams} from '@wix/native-components-infra';
import {CartModel} from '../models/checkout/Cart/Cart.model';

const enum PaymentMethodType {
  PAYPAL = 'paypal',
}

const enum EventAction {
  AgreeToTerms = 'Agree To Terms',
}

const origin = 'Stores';
const eventCategory = 'Enhanced Ecommerce - Stores';

export const FastFlowAnalyticsEventParams = ['AddPaymentInfo', {option: PaymentMethodType.PAYPAL, origin}] as [
  ITrackEventName,
  ITrackEventParams
];

export const AgreeToTermsAnalyticsEventParams = [
  'CustomEvent',
  {
    eventCategory,
    action: EventAction.AgreeToTerms,
    eventLabel: origin,
  },
] as [ITrackEventName, Record<string, any>];

export const StartPayment = [
  'StartPayment' as ITrackEventName,
  {
    origin,
  },
] as [ITrackEventName, Record<string, any>];

export const AddPaymentInfo = ({activePaymentMethod}: {activePaymentMethod?: string}) =>
  [
    'AddPaymentInfo' as ITrackEventName,
    {
      origin,
      option: activePaymentMethod,
    },
  ] as [ITrackEventName, Record<string, any>];

export const trackInitiateCheckout = ({cart}: {cart: CartModel}) => {
  const contents = cart.lineItems.map((item) => ({
    id: item.source.catalogReference?.catalogItemId,
    name: item.name,
    category: 'All Products',
    price: item.pricing.totalPrice?.amount,
    currency: cart.paymentInfo.currencyCode,
    quantity: item.quantityInfo.quantity,
  }));

  return [
    'InitiateCheckout' as ITrackEventName,
    {
      contents,
      origin: 'Stores',
    },
  ] as [ITrackEventName, Record<string, any>];
};
